import { separateStringWithDots } from "./separateStringWithDots";

export const calculateEmail = (email) => {
    const regex1 = /\.[A-Za-z]{2,6}\./;
    const regex2  = /\.[A-Za-z]{2,6}/;
    const emails = email ? email?.includes(';') ? email?.split(';') : email?.includes(', ') ? email?.split(', ') : email?.includes(',') ?  email?.split(',') : regex1.test(email) ? separateStringWithDots(email) : email?.split()?.length ? email?.split() : [] : email || ""
    return emails?.length ? emails?.map(e => !regex2.test(e) ? e+'notanemail@gmail.com' : e) : []
}